import { useGlobalContext } from "@root/context";
import type { ISettingValueMaster } from "@root/types/setting";
import { useMemo, useState } from "react";

interface TagOption {
  label: string;
  value: string;
  group?: string;
}

export const useModalSocialOfferFormFieldTags = () => {
  const { challenges, settingsV2 } = useGlobalContext();
  const [localValues, setLocalValues] = useState<TagOption[]>([]);

  const options: Pick<ISettingValueMaster, "label" | "value" | "group">[] = useMemo(
    () =>
      challenges.flatMap((challenge) =>
        challenge.tags
          .filter((tag) => settingsV2.statusSocialTag?.values.find((v) => v.value === tag))
          .map((tag) => ({
            label: settingsV2.statusSocialTag?.values.find((v) => v.value === tag)?.label ?? tag,
            value: tag,
            group: challenge.name,
          }))
      ),
    [challenges]
  );

  const valueToTagValues = (
    value: string[] | Pick<ISettingValueMaster, "label" | "value" | "group">[]
  ): Pick<ISettingValueMaster, "label" | "value" | "group">[] => {
    return Array.isArray(value)
      ? value.map((v: string | Pick<ISettingValueMaster, "label" | "value" | "group">) =>
          typeof v === "string" ? options.find((opt) => opt.value === v) || { label: v, value: v, group: "" } : v
        )
      : [];
  };

  return {
    options,
    localValues,
    setLocalValues,
    valueToTagValues,
  };
};
